export default __webpack_public_path__ + "static/media/comic7.5db7bdf4.png";